<template>
  <v-menu offset-y v-model="menu" :nudge-width="150" :close-on-click="false" :close-on-content-click="false">
    <template #activator="{on}">
      <v-btn color="primary" dark slot="activator" v-on="on">自定义查询</v-btn>
    </template>
    <gh-custom-filter :conditions="conditions" v-on="liseners" @cancel="menu=false" @submit="submit"></gh-custom-filter>
  </v-menu>
</template>

<style scoped>

</style>

<script>
  import CustormQuery from "./custormQuery.ts";
  export default CustormQuery;
</script>